var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ripa-tree"},[_c('ul',[_c('ripa-node-tree',{attrs:{"node":_vm.treeData}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }